<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? "Edit Collaborator Type" : "Add Collaborator Type" }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 20px">
    <ion-label class="input-label">Name</ion-label>
    <ion-input
      #nameInput
      placeholder="e.g. Dev Owner"
      [(ngModel)]="name"
      class="input-field"
    >
    </ion-input>
    <ion-label class="input-label"> API name </ion-label>
    <ion-input
      *ngIf="!id"
      placeholder="my_field_name"
      class="input-field"
      [disabled]="true"
      [value]="generateKey()"
    ></ion-input>
    <ion-input
      *ngIf="id"
      placeholder="my_field_name"
      class="input-field"
      [disabled]="true"
      [(ngModel)]="key"
    ></ion-input>
    <ion-label class="input-label"> Description </ion-label>
    <ion-textarea
      #descriptionInput
      placeholder="e.g. Issues that the IT can help with"
      [(ngModel)]="description"
      class="input-field"
      rows="6"
    >
    </ion-textarea>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save collaborator type
    <ion-spinner
      name="crescent"
      [hidden]="!isLoading"
      style="margin-left: 10px"
    ></ion-spinner>
  </ion-button>
  <ion-button
    color="danger"
    fill="clear"
    (click)="delete()"
    [disabled]="isLoading"
    *ngIf="id"
  >
    Delete
  </ion-button>
</ion-footer>
